import { useEffect, useState } from "react";

// Returns the CMS image map for a public page ({"section.slot": url}).
export function usePageImages(slug) {
  const [images, setImages] = useState({});
  useEffect(() => {
    let off = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/page-images/${slug}`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (!off && d) setImages(d.images || {}); })
      .catch(() => {});
    return () => { off = true; };
  }, [slug]);
  return images;
}
